import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Spin } from 'antd';
import styles from './Introduccio.module.css';
import IntroduccioData from './IntroduccioData';
import IntroduccioObservador from '../introduccio/IntroduccioObservador';
import IntroduccioObservadorNoAdmin from '../introduccio/IntroduccioObservadorNoAdmin';
import IntroduccioIndividu from '../introduccio/IntroduccioIndividu';
import {
  obtenirDadesIntroduccio,
  obtenirObservadorsActiusEnDataIntroduccio,
  omplirIdObservadorIntroduccio,
  setTitolApartat,
  errorConsultaServidor,
  obtenirDadesUsuariPerIdObservador,
  omplirDataIntroduccio,
  esborrarValors
} from '../../actions';
import {
  getPeticioIntroduccioEnCurs,
  getUsuari,
  getDataDarreraIntroduccio,
  getIdObservador,
} from '../../reducers';
import {
  MISSATGE_SPIN_ESPECIES,
  TITOL_INTRODUCCIO,
  MISSATGE_SESSIO_CADUCADA,
  MISSATGE_TORNAR_FER_LOGIN
} from '../../constantsFormularis';
import {
  fetchObtenirObservador,
  fetchLoginAmbToken,
} from '../../actions/consultesServidor';
import { rutaLogin, rutaPujarFotos } from '../../routes';
import {
  calFerLogin,
  senseRols,
  isObservadorAdmin,
  tokenDecoded,
  getIdObservadorToken
} from '../../utils/usuariRols';
import { LOCAL_STORAGE_USER } from '../../constantsObservacions';
import { eliminarToken } from '../../utils/gestioWebToken';
import { mostrarMissatgeError } from '../../utils/gestioErrorsXarxa';
import {
  MASCARA_DDMMYYYY,
  textAMoment,
  esAnteriorDesdeDataActualSinHora,
  dataActual,
} from '../../utils/dates';
import { crearNotificacioNoConsultaInsercioObservacionsDiaEscollit } from '../../utils/notificacio';

class Introduccio extends React.Component {
  state = {
    observador: {},
  };

  componentDidMount() {
    this._isMounted = true;
    this.recuperarUsuari(this.props.usuari);
    this.props.setTitolApartat(TITOL_INTRODUCCIO);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  redirigirALogin = () => {
    const { history, esborrarValors } = this.props;
    esborrarValors();
    if (history && history.push) {
      history.push({
        pathname: rutaLogin
      });
    }
  };

  esErrorRedirigirALogin = (tipusError, isAdmin) => {
    if (!tipusError) {
      return false;
    }

    if (tipusError.startsWith("Error validació paràmetres")) {
      return true;
    }

    const tipusErrorLlista = "Error de connexió";
    const errorStatusNoAutorizado = 401;

    return (tipusError === tipusErrorLlista && !isAdmin) || tipusError.status === errorStatusNoAutorizado
  }

  recuperarUsuari = (usuari) => {
    if (!calFerLogin(usuari)) {
      this.tokenTrobat(usuari);
    } else {
      this.props.obtenirDadesUsuariPerIdObservador();
      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        fetchLoginAmbToken().then(
          (token) => {
            this.tokenTrobat(token);
          },
          () => {
            eliminarToken();
            this.redirigirALogin();
            return this.props.errorConsultaServidor(
              { status: 401 },
              MISSATGE_SESSIO_CADUCADA
            );
          }
        );
      } else {
        this.redirigirALogin();
        return this.props.errorConsultaServidor(
          { status: 401 },
          MISSATGE_SESSIO_CADUCADA
        );
      }
    }
  };

  recuperarUsuariRender = (usuari) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    if (!token) {
      return <Redirect to={rutaLogin} />;
    }
    if (!calFerLogin(usuari)) {
      return this.tokenTrobatRender(usuari);
    } else {
      return this.tokenTrobatRender(tokenDecoded(token.token));
    }
  };

  tokenTrobat = (usuari) => {
    const { location } = this.props;
    const isAdmin = isObservadorAdmin(usuari);
    if (!isAdmin && usuari && usuari.idObservador) {
      fetchObtenirObservador(usuari.idObservador).then(
        (observador) => {
          if (!this._isMounted) {
            return;
          }
          this.setState({ observador: observador });
          this.omplirObservadorNoAdm(usuari.idObservador);
        },
        (error) => {
          this.props.errorConsultaServidor(
            error,
            error.titol ? error.titol : "Error Obtenint dades de l'observador."
          );
        }
      );
    } else {
      const render =
        location && location.query && location.query.hasOwnProperty('render')
          ? location.query.render
          : true;

      if (render) {
        this.onChangeData();
      }
    }
  };

  mostrarDataDarreraObservacio = (data) => {
    return (
      <div className={styles.ultimaData}>
        <label htmlFor="id-lastupdate">Última observació introduïda</label>
        <span id="id-lastupdate">{data}</span>
      </div>
    );
  };

  generarBotoPujarFotos = (nomObservador) => {
    if (!nomObservador || !nomObservador.trim()) return null;
    return (
      <Link
        to={{
          pathname: rutaPujarFotos,
          query: { render: true },
          state: { observador: nomObservador },
        }}
      >
        <Button type="primary" icon="upload" size="large">
          Enviar Fotos
        </Button>
      </Link>
    );
  };

  tokenTrobatRender = (usuari) => {

    const { isPeticioEnCurs, history, dataDarreraObservacio } = this.props;
    const mostrarDataDarreraObservacio = this.validarMostrarData(
      dataDarreraObservacio
    );
    const isAdmin = isObservadorAdmin(usuari);
    const nomObservador = this.getNomObservador();
    const botoPujarFotos = this.generarBotoPujarFotos(nomObservador);
    const idObservadorToken = getIdObservadorToken();

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    return (
      <Spin spinning={isPeticioEnCurs} tip={MISSATGE_SPIN_ESPECIES} delay={300}>
        {!isAdmin && (
          <IntroduccioObservadorNoAdmin nomObservador={nomObservador} />
        )}
        <div className={styles.introduccio} role="search">
          {isAdmin && (
            <IntroduccioObservador idObservadorToken={idObservadorToken} onChange={this.getDadesIntroduccion} />
          )}
          <IntroduccioData onChange={this.onChangeData} />
          {mostrarDataDarreraObservacio
            ? this.mostrarDataDarreraObservacio(dataDarreraObservacio)
            : null}
        </div>
        <div>
          <IntroduccioIndividu history={history} />
        </div>
        <div className={styles.btnPujaFoto}>{botoPujarFotos}</div>
      </Spin>
    );
  };

  omplirObservadorNoAdm = (idObservador) => {
    this.props.omplirIdObservadorIntroduccio(idObservador);
    this.getDadesIntroduccion();
  };

  objectHasProperties = (objecte) => {
    let hasproperties = false;
    for (let prop in objecte) {
      if (objecte.hasOwnProperty(prop)) {
        hasproperties = true;
      }
    }
    return hasproperties;
  };

  onChangeData = () => {
    //Primer actualitzem el llistat d'observadors, ja que pot ser que en la nova
    //data seleccionada l'observador que estava seleccionat no existeixi
    this.props
      .obtenirObservadorsActiusEnDataIntroduccio()
      .then((dades) => {
        const errorXarxa = mostrarMissatgeError(dades);
        if (errorXarxa) {
          return this.props.errorConsultaServidor(
            errorXarxa.error,
            errorXarxa.missatge
          );
        }
        if (dades && this.objectHasProperties(dades.payload)) {
          this.getDadesIntroduccion();
        } else {
          this.props.omplirIdObservadorIntroduccio(
            this.props.idObservadorIntroduccio
          );
          this.props.omplirDataIntroduccio(dataActual());
          crearNotificacioNoConsultaInsercioObservacionsDiaEscollit();
          this.props.obtenirObservadorsActiusEnDataIntroduccio();
          this.getDadesIntroduccion();
        }
      })
      .catch((error) => {
        if (error.message && error.titol) {
          return this.props.errorConsultaServidor(error.titol, error.message);
        }
      });
  };

  getDadesIntroduccion = () => {
    const idObservadorToken = getIdObservadorToken();
    this.props
      .obtenirDadesIntroduccio(idObservadorToken)
      .then((dades) => {
        const isAdmin = isObservadorAdmin(this.props.usuari);
        const errorXarxa = mostrarMissatgeError(dades);

        if (errorXarxa) {
          if (this.esErrorRedirigirALogin(errorXarxa.error, isAdmin)) {
            this.redirigirALogin();
          }
          return this.props.errorConsultaServidor(
            errorXarxa.error,
            errorXarxa.missatge + " " + MISSATGE_TORNAR_FER_LOGIN
          );
        }
      })
      .catch((error) => {
        if (error && (error === "Error de connexió" || error.status === 401)) {
          this.redirigirALogin();
        }
        if (error.message && error.titol) {
          return this.props.errorConsultaServidor(error.titol, error.message + " " + MISSATGE_TORNAR_FER_LOGIN);
        }
      });
  };

  getNomObservador = () => {
    if (!this.state.observador) {
      return null;
    }

    const nomObservador = `${this.state.observador.nom ? this.state.observador.nom : ''
      } ${this.state.observador.cognom1 ? this.state.observador.cognom1 : ''} ${this.state.observador.cognom2 ? this.state.observador.cognom2 : ''
      }`;
    return nomObservador;
  };

  validarMostrarData = (data) => {
    if (!data) {
      return false;
    }
    return esAnteriorDesdeDataActualSinHora(
      textAMoment(data, MASCARA_DDMMYYYY),
      6,
      'days'
    );
  };

  render() {
    return this.recuperarUsuariRender(this.props.usuari);
  }
}

Introduccio.propTypes = {
  isPeticioEnCurs: PropTypes.bool,
  obtenirDadesIntroduccio: PropTypes.func.isRequired,
  obtenirObservadorsActiusEnDataIntroduccio: PropTypes.func.isRequired,
  omplirIdObservadorIntroduccio: PropTypes.func.isRequired,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  history: PropTypes.object,
  usuari: PropTypes.object,
  obtenirDadesUsuariPerIdObservador: PropTypes.func.isRequired,
  omplirDataIntroduccio: PropTypes.func.isRequired,
  esborrarValors: PropTypes.func.isRequired,
  dataDarreraObservacio: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    isPeticioEnCurs: getPeticioIntroduccioEnCurs(state),
    usuari: getUsuari(state),
    dataDarreraObservacio: getDataDarreraIntroduccio(state),
    observadors: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.number.isRequired,
        nom: PropTypes.string.isRequired,
        cognom1: PropTypes.string.isRequired,
        cognom2: PropTypes.string.isRequired,
      })
    ),
    idObservadorIntroduccio: getIdObservador(state),
  };
};

const mapDispatchToProps = {
  obtenirDadesIntroduccio,
  obtenirObservadorsActiusEnDataIntroduccio,
  omplirIdObservadorIntroduccio,
  setTitolApartat,
  errorConsultaServidor,
  obtenirDadesUsuariPerIdObservador,
  omplirDataIntroduccio,
  esborrarValors
};

export default connect(mapStateToProps, mapDispatchToProps)(Introduccio);
